import { render } from "./SelectBrand.vue?vue&type=template&id=d3ef36ae"
import script from "./SelectBrand.vue?vue&type=script&lang=js"
export * from "./SelectBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__